import React, { useState } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { sendEmailVerificationLink } from "../../../http/http-calls";
import { errorHandler, showToast } from "../../../helper-methods";

const EmailVerificationModal = ({ isOpen, data, toggle }) => {
  // console.log("data: ", data);
  const [isLoading, setIsLoading] = useState(false)

  const _onClose = () => {
    setIsLoading(false);
    toggle();
  }

  const _handleSubmit = async () => {
    try {
      setIsLoading(true);

      const payload = {
        handle: data?.handle,
        site:
          window.location.hostname !== "localhost"
            ? window.location.host
            : "customizedwl.logic-square.com",
      };
      await sendEmailVerificationLink(payload);

      _onClose();
      showToast("Email verification link sent", "success");
    } catch (err) {
      console.log(err);
      errorHandler(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} centered>
      <ModalHeader toggle={() => _onClose()}>Email Not Verified!</ModalHeader>
      <ModalBody className="modalContent">
        <p className="text-center">
          Send the verification email to{" "}
          <span style={{ fontWeight: 600 }}>{data?.handle}</span> ?
        </p>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" outline onClick={() => _onClose()}>
          Cancel
        </Button>
        <Button color="primary" onClick={() => _handleSubmit()} disabled={isLoading}>
          Send {isLoading ? <i className="fa fa-spinner fa-spin mr-1" /> : null}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default EmailVerificationModal;
